import AccordionContainer from '@aspendental/shared-components-web/lib/components/Accordions/AccordionContainer';
import InsuranceList from '@aspendental/shared-components-web/lib/components/Insurance/InsuranceList/InsuranceList';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { IProviderDetailsPage } from './ProviderDetailsPage';
import { getProviderContentContainerStyles, providerAboutTitleStyles } from './ProviderDetailsPage.styles';

export default function ProviderSpecialties({ provider }: IProviderDetailsPage) {
	const theme = useTheme();
	const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const insuranceObj = provider.providerLocations?.reduce((accumulator, currentValue) => {
		const insurances = currentValue.facility?.insuranceInfo?.companies as { name: string }[];
		if (insurances && insurances.length > 0) {
			const availableInsurances = insurances.reduce((acc, cur) => ({ ...acc, [cur.name]: true }), {});
			return { ...accumulator, ...availableInsurances };
		} else {
			return accumulator;
		}
	}, {});

	const insuranceList = Object.keys(insuranceObj as Record<string, boolean>).map((insuranceName) => ({
		name: insuranceName,
	}));

	if (!insuranceList || insuranceList?.length < 1) {
		return null;
	}

	return (
		<Box data-testid="provider_insurance_container" sx={getProviderContentContainerStyles}>
			<Typography
				variant="header2"
				color="text.primary"
				component="h2"
				data-testid="provider_insurance_title"
				sx={providerAboutTitleStyles}
			>
				Insurance
			</Typography>
			<AccordionContainer
				isSmallScreen={isMobileScreen}
				items={[
					{
						id: 'provider_insurance',
						title: 'Insurance',
						children: <InsuranceList insuranceList={insuranceList} withDivider={false} />,
					},
				]}
			/>
		</Box>
	);
}
